import React, { createContext, useState } from "react";
import { generateIACarePlan } from "../../utils/services/Careplans/IACareplans/generateIACarePlan";
import { useValidToken } from "../../hooks/useValidToken";

export const IACarePlanContext = createContext();

export const IACarePlanProvider = ({ children }) => {
  const [resultado, setResultado] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { token, isValid, authLoading } = useValidToken();

  const generatePlan = async (patientData) => {
    // HIPAA: no loguear patientData ni respuestas (contienen PHI) — 45 CFR 164.530(c)
    if (!isValid || authLoading) {
      console.warn("[IACarePlanContext] ⚠ Aborted — token invalid or auth still loading");
      return;
    }

    setLoading(true);
    setError(null);
    setResultado("");

    try {
      const data = await generateIACarePlan(patientData);
      setResultado(data.resultado);
    } catch (err) {
      // Solo status y mensaje — nunca err.response.data (puede contener PHI)
      console.error("[IACarePlanContext] Error generating plan:", err.response?.status, err.message);
      setError("Error generando el plan. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <IACarePlanContext.Provider
      value={{
        resultado,
        loading,
        error,
        generatePlan,
      }}
    >
      {children}
    </IACarePlanContext.Provider>
  );
};
